function CowsayCommand() {
  return ` ________________________
< Bienvenue sur mon cv ! >
 ------------------------
        \\   ^__^
         \\  (oo)\\_______
            (__)\\       )\\/\\
                ||----w |
                ||     ||`;
}

export default CowsayCommand;



// WEBPACK FOOTER //
// ./src/commands/CowsayCommand.js